export default "__VITE_ASSET__DwtyHxX0__"